import * as React from "react";
import { GridColumnMenuCheckboxFilter } from "@progress/kendo-react-grid";

export class ColumnMenuCheckboxFilter extends React.Component {
  componentDidMount() {
    this.getSelectedColumn();
  }

  getSelectedColumn = () => {
    let col = this.props.column.field;
    this.props.getSelectedColumn(col);
  };
  render() {
    return (
      <div style={{color:'white'}}>
        <GridColumnMenuCheckboxFilter
          {...this.props}
          data={this.props.data}
          expanded={true}
          searchBox={() => null}
        />
      </div>
    );
  }
}
